<template>
  <div class="html-item-wrap" v-html="showText"></div>
</template>

<script setup>
import { computed } from 'vue';
import useLocate from './uses/useLocate.js';
import { useRenderConfig } from './uses/useRenderConfig.js';
import { resolveBindDataKeyValue } from '@/utils/renderBinding';

const { nowLocale } = useLocate();

const props = defineProps({
  currentElementIndex: {
    type: Array,
    default: () => [],
  },
  idx: {
    type: Number,
    default: -1,
  },
  parentKeys: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  config: {
    type: Object,
  },
});

const { bindData } = useRenderConfig(() => props.config);

const rawHtmlContent = computed(() => {
  const multiLangContent = props.config?.multiLangContent || {};
  if (props.config?.enableMultiLang) {
    return (
      multiLangContent[nowLocale.value] ||
      multiLangContent.hans ||
      props.config?.content ||
      ''
    );
  }
  return props.config?.content || '';
});

const showText = computed(() => {
  return resolveBindDataKeyValue(
    bindData.value,
    props.config?.bindDataKey,
    rawHtmlContent.value,
  );
});
</script>

<style scoped>
.html-item-wrap {
  display: block;
  width: 100%;
}
</style>
  
